import { useCallback } from 'react';
import api from '../api';
import { ValuesOfObject } from '../@types/utils';
import { ANALYTICS_EVENT_SUBLOCATIONS, ANALYTICS_EVENT_TYPES } from '../constants/analyticsEvents';

const API_URL = '/events/';
const LOCATION_ID = 'portaal';

export type AnalyticsEvent = {
  eventType: ValuesOfObject<typeof ANALYTICS_EVENT_TYPES>;
  objectId?: string;
  subObjectId?: string;
  subLocationId?: ValuesOfObject<typeof ANALYTICS_EVENT_SUBLOCATIONS>;
  duration?: number;
};

function useAnalytics(): {
  capture: (event: AnalyticsEvent) => Promise<void>;
} {
  const capture = useCallback(async (event: AnalyticsEvent) => {
    try {
      await api.post<void>(API_URL, {
        ...event,
        locationId: LOCATION_ID,
      });
    } catch (error) {
      console.error(error);
    }
  }, []);

  return { capture };
}

export default useAnalytics;
